import { Component, OnInit } from '@angular/core';
import {User} from '../../../models/user';
import {TrackingLocation} from '../../../models/tracking-location';
import {Market} from '../../../models/market';
import {MarketLevel} from '../../../models/market-level';
import {Subject} from 'rxjs';
import {ActivatedRoute} from '@angular/router';
import {BaseService} from '../../../services/base.service';
import {AuthService} from '../../../services/auth.service';
import {MatCheckboxChange, MatSelectChange} from '@angular/material';
import { TitleBroadcastService } from 'app/services/title-broadcast.service';

@Component({
  selector: 'app-distributor-location-list',
  templateUrl: './distributor-location-list.component.html',
  styleUrls: ['./distributor-location-list.component.scss']
})
export class DistributorLocationListComponent implements OnInit {

    lat = 23.8383283;
    lng = 90.3759853;

    loggedUser: User;
    distributorLocationList: TrackingLocation[] = [];
    loadingData = false;
    markets = [];
    selectedMarket: Market[] = [];
    marketLevels: MarketLevel[] = [];

    filters = {
        'MarketIdList': null,
    };


    private _unsubscribeAll: Subject<any>;

    constructor( private route: ActivatedRoute, private service: BaseService, private auth: AuthService,private titleBroadcastService: TitleBroadcastService ) {
        this._unsubscribeAll = new Subject();
        this.titleBroadcastService.title.next('Distributor Location');
        this.loggedUser = auth.user;

        this.marketLevels = this.loggedUser.MarketLevelHierarchy;
        this.marketLevels.forEach( marketLevel => {
            this.markets[ marketLevel.Rank ] = [];
            this.selectedMarket[ marketLevel.Rank ] = null;
        } );
    }

    ngOnInit(): void {
        this.service.getMarketList({MarketLevelId: this.marketLevels[0].Id, Active: true}).subscribe(pMarkets => this.markets[1] = pMarkets);
    }

    ngAfterViewInit(): void {
        this.service.getMarketList( {
            MarketLevelId: this.marketLevels[ 0 ].Id,
            Active       : true
        } ).subscribe( marketListResponse => {
            this.markets[ 1 ] = marketListResponse;
        } );
    }


    _resetChildDropdowns( pParentRank: number ): void {
        this.marketLevels.forEach( marketLevel => {
            if ( marketLevel.Rank > pParentRank ) {
                this.selectedMarket[ marketLevel.Rank ] = null;
                this.markets[ marketLevel.Rank ] = [];
            }
        } );
    }

    populateChildrenMarkets( event: MatSelectChange ): void {
        const market: Market = event.value;
        if ( market ) {
            this._resetChildDropdowns( market.MarketLevel.Rank );
            if ( this.marketLevels[ market.MarketLevel.Rank ] ) {
                this.service.getMarketList( {
                    MarketLevelId : this.marketLevels[ market.MarketLevel.Rank ].Id,
                    ParentMarketId: market.Id,
                    Active        : true
                } ).subscribe( marketListResponse => {
                    this.markets[ market.MarketLevel.Rank + 1 ] = marketListResponse;
                } );
            }
        }
        else {
            this._resetChildDropdowns( parseInt( event.source.id.slice( 6 ), 10 ) );
        }
    }

    getLocationList(): void {

        this.loadingData = true;
        this.filters.MarketIdList = null;
        for ( let i = this.selectedMarket.length - 1; i >= 0; i-- ) {
            if ( this.selectedMarket[ i ] ) {
                this.filters.MarketIdList = [ this.selectedMarket[ i ].Id ];
                break;
            }
        }

        this.loadingData = true;

            this.service.getDistributorLocationList( this.filters ).subscribe( locationList => {
                this.loadingData = false;
                    if ( locationList.length > 0 ) {
                        this.lat = locationList[ 0 ].Latitude;
                        this.lng = locationList[ 0 ].Longitude;
                    }

                    this.distributorLocationList = locationList;
                }, error => {
                    this.loadingData = false;
                } );


    }


}
